import type { SVGProps } from 'react';
const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M11.3782 16.4523L4.25757 9.33165C3.91414 8.98823 3.91414 8.43145 4.25757 8.08807L5.08808 7.25756C5.43091 6.91472 5.98655 6.91406 6.33019 7.25609L12 12.8994L17.6698 7.25609C18.0134 6.91406 18.5691 6.91472 18.9119 7.25756L19.7424 8.08807C20.0859 8.43149 20.0859 8.98826 19.7424 9.33165L12.6218 16.4523C12.2784 16.7957 11.7216 16.7957 11.3782 16.4523Z" />
  </svg>
);
export default SvgChevronDown;
